import { FC, useMemo, useCallback, useState, useEffect } from 'react';
import { Loading, ReportCard, Section, Table } from '../../../../components';
import { useToastStore } from '../../../../stores';
import {
	getAllDealers,
	TConcessionaria,
} from '../../../../services';
import {
	NoData,
	Separator,
	TableContainer,
	TableWrapper,
	TitleContainer,
} from '../../Reports.styles';

const AdminDealerReport: FC = () => {
	const { setToast } = useToastStore();
	const [loading, setLoading] = useState(false);
	const [dealer, setDealers] = useState<TConcessionaria[]>([]);
	const [clickGenerate, setClickGenerate] = useState(false);

	const fetchData = async () => {
		setLoading(true);
		const data = await getAllDealers() ;

		if (!data) {
			setToast({ variant: 'error', message: 'Erro ao buscar dados!' });
			setLoading(false);
			return;
		}

		setDealers(data);
		setClickGenerate(true);
		setLoading(false);
	};

	const tableColumns = useMemo(
		() => [

			{ id: 'groupDealer', label: 'Grupo', width: '100px' },
			{ id: 'fantasia', label: 'Nome Fantasia' },
			{ id: 'numeroDocumento', label: 'CNPJ' },
			{ id: 'cidade', label: 'Cidade' },
			{ id: 'responsavel', label: 'Responsável' },
			{ id: 'tagAtivo', label: 'Status', width: '100px' }
		],
		[]
	);

	const rowMapper = useCallback(
		(dealerData: TConcessionaria) => ({
			groupDealer: {
				value: dealerData.grupoConcessionaria.grupoConcessionaria,
				rawValue: dealerData.grupoConcessionaria.grupoConcessionaria,
			},
			fantasia: {
				value: dealerData.fantasia,
				rawValue: dealerData.fantasia,
			},
			numeroDocumento: {
				value: dealerData.cnpj,
				rawValue: dealerData.cnpj,
			},
			cidade: {
				value: dealerData.cidade,
				rawValue: dealerData.cidade,
			},
			responsavel: {
				value: dealerData.cidade,
				rawValue: dealerData.cidade,
			},
			tagAtivo: {
				value: (dealerData.tagAtivo === '1' ? 'Ativo' : 'Inativo'),
				rawValue: dealerData.tagAtivo,
			}
		}),
		[]
	);

	const MemoizedTable = useMemo(
		() => <Table columns={tableColumns} rows={dealer?.map(rowMapper)} paginate exportToPDF exportToCSV />,
		[dealer, rowMapper, tableColumns]
	);

	useEffect(() => {
		fetchData();
	}, []);

	return (
		<Section>
			<TitleContainer>Relatório de Concessionárias</TitleContainer>
			<Separator />
			{loading && <Loading />}
			{dealer?.length > 0 && (
				<ReportCard
					data={[
						{
							color: '#FF9800',
							title: 'Qtde Total de Concessionárias',
							value: dealer.length,
						},
						{
							color: '#4CAF50',
							title: 'Qtde Concessionárias Ativas',
							value: dealer.filter((dealerData) => dealerData.tagAtivo === '1').length,
						},
						{
							color: '#f44336',
							title: 'Qtde Concessionárias Inativas',
							value: dealer.filter((dealerData) => dealerData.tagAtivo === '0').length,
						}
					]}
				/>
			)}
			<TableContainer>
				{(loading || (dealer?.length || 0) > 0) && (
					<TableWrapper>{loading ?  <Loading /> : MemoizedTable}</TableWrapper>
				)}
				{!loading && clickGenerate && dealer?.length === 0 && (
					<NoData>Nenhum registro encontrado</NoData>
				)}
			</TableContainer>
			
		</Section>
	);
};

export default AdminDealerReport;
